/**
 * @generated SignedSource<<3823e14d417b69e84ad7482411f3902e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueSummaryCell_issue$data = {
  readonly __id: string;
  readonly id?: string;
  readonly isRemoteIssue?: boolean | null | undefined;
  readonly key: string;
  readonly webUrl?: AGG$URL | null | undefined;
  readonly " $fragmentType": "IssueSummaryCell_issue";
};
export type IssueSummaryCell_issue$key = {
  readonly " $data"?: IssueSummaryCell_issue$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueSummaryCell_issue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isRemoteLinkedIssuesEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "IssueSummaryCell_issue",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "condition": "isRemoteLinkedIssuesEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isRemoteIssue"
        },
        {
          "kind": "ScalarField",
          "name": "webUrl"
        }
      ]
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "94c423e4276945fd081d35286ac16a82";

export default node;
